(function() {
  'use strict';

  // ============================================================
  // STATE
  // ============================================================
  var section, workerUrl;
  var heroImage, promoEnabled, promoImage, promoHeading, promoText, promoCtaLabel, promoCtaUrl;
  var formEl, formWrapEl, loadingEl, errorEl, resultsEl;

  // ============================================================
  // HELPERS
  // ============================================================

  function show(el) { if (el) el.style.display = ''; }
  function hide(el) { if (el) el.style.display = 'none'; }

  function trackEvent(name, data) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: name }, data || {}));
  }

  function escapeHtml(str) {
    if (str === null || str === undefined) return '';
    return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function formatShortDate(iso) {
    if (!iso) return '';
    try {
      var d = new Date(iso);
      return d.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' });
    } catch (e) { return ''; }
  }

  function formatDayNumber(iso) {
    if (!iso) return '';
    try {
      var d = new Date(iso);
      return d.getDate();
    } catch (e) { return ''; }
  }

  function formatMonth(iso) {
    if (!iso) return '';
    try {
      var d = new Date(iso);
      return d.toLocaleDateString('en-US', { month: 'long' });
    } catch (e) { return ''; }
  }

  function formatWeekday(iso) {
    if (!iso) return '';
    try {
      var d = new Date(iso);
      return d.toLocaleDateString('en-US', { weekday: 'long' });
    } catch (e) { return ''; }
  }

  function formatDateTime(iso) {
    if (!iso) return '';
    try {
      var d = new Date(iso);
      return d.toLocaleDateString('en-US', {
        month: 'short', day: 'numeric',
        hour: 'numeric', minute: '2-digit'
      });
    } catch (e) { return ''; }
  }

  function imageSize(url, size) {
    if (!url) return '';
    return url.replace(/\.([a-z]+)(\?|$)/, '_' + size + '.$1$2');
  }

  // ============================================================
  // STATUS MAPPINGS
  // ============================================================

  // Map status → which step (0/1/2) is the current/latest reached
  // 0 = Order received, 1 = Shipped, 2 = Delivered
  function statusToStep(status) {
    switch (status) {
      case 'delivered': return 2;
      case 'out_for_delivery':
      case 'in_transit': return 1;
      case 'pre_transit':
      case 'exception':
      case 'returned':
      case 'unknown':
      default: return 0;
    }
  }

  // Headline shown above the status card
  function statusHeadline(status) {
    switch (status) {
      case 'delivered': return 'Your order has arrived';
      case 'out_for_delivery': return 'Out for delivery today';
      case 'in_transit': return 'Your order is on the move';
      case 'exception': return 'There\u2019s an issue with your shipment';
      case 'returned': return 'Your order is being returned';
      case 'pre_transit': return 'Your order is on the way';
      default: return 'Your order is being prepared';
    }
  }

  // Status label for the first (current-step) card
  function currentStepLabel(status) {
    switch (status) {
      case 'delivered': return 'Delivered';
      case 'out_for_delivery': return 'Out for delivery';
      case 'in_transit': return 'In transit';
      case 'exception': return 'Shipment exception';
      case 'returned': return 'Being returned';
      case 'pre_transit': return 'Order received';
      default: return 'Order received';
    }
  }

  // ============================================================
  // API CALLS
  // ============================================================

  // Single atomic call — Worker validates order via Shopify first,
  // then fetches tracking (cache-first, Ship24 on miss) server-side.
  // Response includes fulfillments with their tracking data inline.
  function lookupOrder(email, orderNumber) {
    return fetch(workerUrl + '/order', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email: email,
        orderNumber: orderNumber,
        website: ''
      })
    }).then(function(resp) {
      return resp.json().then(function(data) {
        if (!resp.ok) throw new Error(data.message || 'Order not found');
        return data;
      });
    });
  }

  // ============================================================
  // RENDERERS
  // ============================================================

  function renderHero() {
    if (!heroImage) return '';
    return '' +
      '<div class="tracking-hero">' +
        '<img src="' + escapeHtml(heroImage) + '" alt="" loading="lazy">' +
      '</div>';
  }

  function renderStatusCard(orderData, primaryTracking) {
    var status = primaryTracking ? primaryTracking.status : 'pre_transit';
    var currentStep = statusToStep(status);
    var headline = statusHeadline(status);
    var stepLabel = currentStepLabel(status);

    // Determine primary date
    var primaryDate = '';
    var primaryLabel = '';
    if (status === 'delivered' && primaryTracking && primaryTracking.deliveredAt) {
      primaryDate = primaryTracking.deliveredAt;
      primaryLabel = 'Delivered';
    } else if (primaryTracking && primaryTracking.estimatedDelivery) {
      primaryDate = primaryTracking.estimatedDelivery;
      primaryLabel = 'Estimated delivery';
    } else {
      primaryDate = orderData.order.createdAt;
      primaryLabel = 'Ordered';
    }

    var hasTrackingEvents = primaryTracking && primaryTracking.events && primaryTracking.events.length > 0;

    var html = '' +
      '<div class="tracking-status-card">' +
        '<h2 class="tracking-status-card__headline">' + escapeHtml(headline) + '</h2>' +
        '<div class="tracking-status-card__body">' +
          '<div class="tracking-status-card__date">' +
            '<div class="tracking-status-card__date-label">' + escapeHtml(primaryLabel) + '</div>' +
            (primaryDate
              ? '<div class="tracking-status-card__date-weekday">' + formatWeekday(primaryDate) + ', ' + formatMonth(primaryDate) + '</div>' +
                '<div class="tracking-status-card__date-day">' + formatDayNumber(primaryDate) + '</div>'
              : '') +
          '</div>' +
          '<ol class="tracking-stepper" data-current-step="' + currentStep + '">' +
            '<li class="tracking-stepper__step' + (currentStep >= 0 ? ' tracking-stepper__step--active' : '') + (currentStep >= 1 ? ' tracking-stepper__step--complete' : '') + '">' +
              '<span class="tracking-stepper__dot"></span>' +
              '<span class="tracking-stepper__label">' + (currentStep === 0 ? escapeHtml(stepLabel) : 'Order received') + '</span>' +
            '</li>' +
            '<li class="tracking-stepper__step' + (currentStep >= 1 ? ' tracking-stepper__step--active' : '') + (currentStep >= 2 ? ' tracking-stepper__step--complete' : '') + '">' +
              '<span class="tracking-stepper__dot"></span>' +
              '<span class="tracking-stepper__label">' + (currentStep === 1 ? escapeHtml(stepLabel) : 'Shipped') + '</span>' +
            '</li>' +
            '<li class="tracking-stepper__step' + (currentStep >= 2 ? ' tracking-stepper__step--active tracking-stepper__step--complete' : '') + '">' +
              '<span class="tracking-stepper__dot"></span>' +
              '<span class="tracking-stepper__label">Delivered</span>' +
            '</li>' +
          '</ol>' +
        '</div>';

    if (hasTrackingEvents) {
      html += '' +
        '<button type="button" class="tracking-status-card__toggle" aria-expanded="false">' +
          'Track your package' +
        '</button>' +
        '<div class="tracking-status-card__details" hidden>' +
          renderShipmentMeta(primaryTracking) +
          renderTimeline(primaryTracking.events) +
        '</div>';
    }

    html += '</div>';
    return html;
  }

  function renderShipmentMeta(tracking) {
    if (!tracking) return '';
    var carrier = (tracking.carrier || '').toUpperCase();
    return '' +
      '<div class="tracking-shipment-meta">' +
        '<span class="tracking-shipment-meta__carrier">' + escapeHtml(carrier) + '</span>' +
        '<span class="tracking-shipment-meta__number">' + escapeHtml(tracking.trackingNumber) + '</span>' +
      '</div>';
  }

  function renderTimeline(events) {
    if (!events || events.length === 0) return '';
    var html = '<ul class="tracking-timeline">';
    for (var i = 0; i < events.length; i++) {
      var evt = events[i];
      html += '' +
        '<li class="tracking-timeline__event' + (i === 0 ? ' tracking-timeline__event--latest' : '') + '">' +
          '<div class="tracking-timeline__description">' + escapeHtml(evt.description) + '</div>' +
          '<div class="tracking-timeline__meta">' +
            '<span>' + formatDateTime(evt.timestamp) + '</span>' +
            (evt.location ? '<span>' + escapeHtml(evt.location) + '</span>' : '') +
          '</div>' +
        '</li>';
    }
    html += '</ul>';
    return html;
  }

  function renderOrderItems(lineItems) {
    if (!lineItems || lineItems.length === 0) return '';

    var html = '' +
      '<section class="tracking-items">' +
        '<h3 class="tracking-items__title">Items in your order</h3>' +
        '<ul class="tracking-items__list">';

    for (var i = 0; i < lineItems.length; i++) {
      var item = lineItems[i];
      var imgSrc = item.imageUrl ? imageSize(item.imageUrl, '200x200') : '';
      var productUrl = item.productHandle ? '/products/' + item.productHandle : null;

      html += '' +
        '<li class="tracking-item">' +
          '<div class="tracking-item__image">' +
            (imgSrc
              ? (productUrl
                  ? '<a href="' + productUrl + '"><img src="' + escapeHtml(imgSrc) + '" alt="' + escapeHtml(item.title) + '" loading="lazy"></a>'
                  : '<img src="' + escapeHtml(imgSrc) + '" alt="' + escapeHtml(item.title) + '" loading="lazy">')
              : '') +
          '</div>' +
          '<div class="tracking-item__info">' +
            '<p class="tracking-item__title">' +
              (productUrl
                ? '<a href="' + productUrl + '">' + escapeHtml(item.title) + '</a>'
                : escapeHtml(item.title)) +
            '</p>' +
            (item.variantTitle ? '<p class="tracking-item__variant">' + escapeHtml(item.variantTitle) + '</p>' : '') +
            '<p class="tracking-item__qty">Quantity: ' + item.quantity + '</p>' +
          '</div>' +
        '</li>';
    }

    html += '</ul></section>';
    return html;
  }

  function renderPromo() {
    if (!promoEnabled || promoEnabled !== 'true') return '';
    if (!promoHeading && !promoText) return '';

    var hasImage = !!promoImage;

    return '' +
      '<section class="tracking-promo' + (hasImage ? ' tracking-promo--with-image' : '') + '">' +
        '<div class="tracking-promo__content">' +
          (promoHeading ? '<h3 class="tracking-promo__heading">' + escapeHtml(promoHeading) + '</h3>' : '') +
          (promoText ? '<p class="tracking-promo__text">' + escapeHtml(promoText) + '</p>' : '') +
          (promoCtaLabel && promoCtaUrl
            ? '<a href="' + escapeHtml(promoCtaUrl) + '" class="tracking-promo__btn">' + escapeHtml(promoCtaLabel) + '</a>'
            : '') +
        '</div>' +
        (hasImage ? '<div class="tracking-promo__image"><img src="' + escapeHtml(promoImage) + '" alt="" loading="lazy"></div>' : '') +
      '</section>';
  }

  function renderSupport() {
    return '' +
      '<div class="tracking-support">' +
        '<p>Need help with your order?</p>' +
        '<a href="mailto:info@ripndipclothing.com">Contact Support</a>' +
      '</div>';
  }

  function renderError(message) {
    return '' +
      '<div class="tracking-error__message">' +
        '<p>' + escapeHtml(message) + '</p>' +
        '<button class="tracking-error__retry" type="button">Try Again</button>' +
      '</div>';
  }

  // ============================================================
  // EVENT WIRING
  // ============================================================

  function wireDetailsToggle() {
    var btn = resultsEl.querySelector('.tracking-status-card__toggle');
    var details = resultsEl.querySelector('.tracking-status-card__details');
    if (!btn || !details) return;

    btn.addEventListener('click', function() {
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!expanded));
      if (expanded) {
        details.hidden = true;
        btn.textContent = 'Track your package';
      } else {
        details.hidden = false;
        btn.textContent = 'Hide details';
        trackEvent('tracking_details_expanded');
      }
    });
  }

  // ============================================================
  // MAIN FLOW
  // ============================================================

  function handleSubmit(e) {
    e.preventDefault();
    e.stopPropagation();

    if (!workerUrl) {
      errorEl.innerHTML = renderError('Tracking is not yet configured. Please set the Tracking API URL in the theme editor.');
      show(errorEl);
      return false;
    }

    var honeypot = formEl.querySelector('[name="website"]');
    if (honeypot && honeypot.value) return;

    var emailInput = formEl.querySelector('[name="email"]');
    var orderInput = formEl.querySelector('[name="order"]');
    var email = emailInput.value.trim();
    var orderNumber = orderInput.value.trim().replace(/^#/, '');

    if (!email || !orderNumber) return;

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      errorEl.innerHTML = renderError('Please enter a valid email address.');
      show(errorEl);
      return;
    }

    var submitBtn = formEl.querySelector('.tracking-form__btn');
    submitBtn.disabled = true;

    show(loadingEl);
    hide(errorEl);
    hide(resultsEl);

    trackEvent('tracking_form_submit', { order_number: orderNumber });

    lookupOrder(email, orderNumber)
      .then(function(orderData) {
        trackEvent('tracking_order_found', {
          order_number: orderNumber,
          fulfillment_count: orderData.fulfillments.length
        });

        // Tracking data is now included inline on each fulfillment
        var trackingResults = orderData.fulfillments.map(function(f) {
          return f.tracking || null;
        });
        var primaryTracking = trackingResults[0] || null;

        var html = '';
        html += renderHero();
        html += renderStatusCard(orderData, primaryTracking);
        html += renderOrderItems(orderData.lineItems);
        html += renderPromo();
        html += renderSupport();

        resultsEl.innerHTML = html;
        hide(loadingEl);
        hide(formWrapEl); // Collapse form when showing results
        show(resultsEl);

        wireDetailsToggle();

        if (primaryTracking) {
          trackEvent('tracking_status_viewed', {
            carrier: orderData.fulfillments[0] ? orderData.fulfillments[0].carrier : 'unknown',
            status: primaryTracking.status,
            tracking_number: orderData.fulfillments[0] ? orderData.fulfillments[0].trackingNumber : null
          });
        }

        // Update URL for shareability
        try {
          var url = new URL(window.location);
          url.searchParams.set('order', orderNumber);
          url.searchParams.set('email', email);
          history.replaceState(null, '', url);
        } catch (e) {}

        resultsEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
        submitBtn.disabled = false;
      })
      .catch(function(err) {
        hide(loadingEl);
        errorEl.innerHTML = renderError(
          err.message || 'Order not found. Please check your order number and email.'
        );
        show(errorEl);
        submitBtn.disabled = false;

        trackEvent('tracking_order_not_found', { order_number: orderNumber });

        var retryBtn = errorEl.querySelector('.tracking-error__retry');
        if (retryBtn) {
          retryBtn.addEventListener('click', function() {
            hide(errorEl);
            emailInput.focus();
          });
        }
      });
  }

  // ============================================================
  // INIT
  // ============================================================

  function init() {
    section = document.querySelector('[data-section-type="tracking-page"]');
    if (!section) return;

    workerUrl = section.getAttribute('data-worker-url');
    heroImage = section.getAttribute('data-hero-image') || '';
    promoEnabled = section.getAttribute('data-promo-enabled') || 'false';
    promoImage = section.getAttribute('data-promo-image') || '';
    promoHeading = section.getAttribute('data-promo-heading') || '';
    promoText = section.getAttribute('data-promo-text') || '';
    promoCtaLabel = section.getAttribute('data-promo-cta-label') || '';
    promoCtaUrl = section.getAttribute('data-promo-cta-url') || '';

    formWrapEl = section.querySelector('.tracking-form-wrap');
    formEl = section.querySelector('.tracking-form');
    loadingEl = section.querySelector('.tracking-loading');
    errorEl = section.querySelector('.tracking-error');
    resultsEl = section.querySelector('.tracking-results');

    if (formEl) formEl.addEventListener('submit', handleSubmit);

    if (!workerUrl) {
      console.error('Tracking page: Missing Worker URL in section settings.');
      return;
    }

    // Auto-lookup from URL params
    var params = new URLSearchParams(window.location.search);
    var paramOrder = params.get('order');
    var paramEmail = params.get('email');

    if (paramOrder && paramEmail) {
      formEl.querySelector('[name="email"]').value = paramEmail;
      formEl.querySelector('[name="order"]').value = paramOrder;
      setTimeout(function() {
        formEl.dispatchEvent(new Event('submit'));
      }, 300);
    }

    trackEvent('tracking_page_view');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
